// extracted by mini-css-extract-plugin
module.exports = {"UserPage__main":"UserPage_UserPage__main__3zK9T","UserPage__extActions":"UserPage_UserPage__extActions__F0AY-"};